'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _list = require('./list.attribute');

var _list2 = _interopRequireDefault(_list);

var _fields = require('./fields.attribute');

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // List


exports.default = function (attributes, field) {
  (0, _fields2.default)(field);
  return (0, _list2.default)(attributes).reduce(function (data, attribute) {
    return (0, _extends4.default)({}, data, (0, _defineProperty3.default)({}, attribute.attribute, attribute[field].format()));
  }, {});
}; // Fields